import {incomePlanAxios} from '../../axios';

const MARKET_INDEXES_SET = 'MARKET_INDEXES_SET';

export const marketIndexes =  {

    namespaced: true,

    state: {
        marketIndexes: []
    },

    actions: {
        fetchMarketIndexes({commit}) {
            incomePlanAxios
                .get(process.env.VUE_APP_BASE_URL + '/api/market-indexes')
                .then(r => r.data.data)
                .then(response => {
                    commit(MARKET_INDEXES_SET, response);
                });
        }
    },

    mutations: {
        [MARKET_INDEXES_SET](state, data) {
            state.marketIndexes = data;
        }
    }
}
